/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, arrayOf, shape, string,
} from 'prop-types';

import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

class WalletInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = { defaultCard: '' };
    }

    getCardTypeById = (cardtypes, id) => cardtypes.filter((c) => c.id === id)[0].name;

    handleSetDefaultCardClicked = (walletId) => {
        const { onSetDefaultCard } = this.props;
        this.setState({ defaultCard: walletId }, () => {
            onSetDefaultCard(walletId);
        });
    };

    render() {
        // eslint-disable-next-line object-curly-newline
        const {
            wallet,
            cardtypes,
            onAddCard,
            onRemoveCard,
            onEditCard,
        } = this.props;
        const { defaultCard } = this.state;
        const setAdDefaultButton = (walletId) => (defaultCard === walletId ? (
            <div className="margin-top">Set As Default...</div>
        ) : (
            <button
                className="set-default-cc-btn link margin-top"
                onClick={() => this.handleSetDefaultCardClicked(walletId)}
                type="button"
            >
                Set As Default
            </button>
        ));

        return (
            <>
                <h2>Your Payment Methods</h2>
                {wallet.map((w, i) => (
                    <div key={w.walletId}>
                        <div className="split">
                            <div className="bold">
                                {this.getCardTypeById(cardtypes, w.cardType)}
                            </div>
                            <div className="flex-none">
                                <button
                                    className="edit-cc-btn link"
                                    onClick={() => onEditCard(w)}
                                    type="button"
                                >
                                    Edit
                                </button>
                                {w.subsIndicator === '0' ? (
                                    <button
                                        className="remove-cc-btn link margin-left"
                                        onClick={() => onRemoveCard(w.walletId)}
                                        type="button"
                                    >
                                        Delete
                                    </button>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div>
                            &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                            {w.lastFourDigits}
                        </div>
                        <div>{w.cardHolderName}</div>
                        <div className="split">
                            <div>Expires: {w.expiryDate}</div>
                            <div className="flex-none">
                                {w.subsIndicator === '1' ? 'DEFAULT*' : ''}
                            </div>
                        </div>
                        {w.subsIndicator === '0'
                            ? setAdDefaultButton(w.walletId)
                            : ''}
                        <div
                            className={
                                w.subsIndicator === '1'
                                    ? 'margin-top small bold'
                                    : 'display-none'
                            }
                        >
                            *Use this card for Subscription &amp; Passport
                            membership
                        </div>
                        {wallet.length - 1 > i ? (
                            <Divider className="margin-top margin-bottom" />
                        ) : (
                            ''
                        )}
                    </div>
                ))}
                {wallet.length === 0 ? (
                    <p>
                        You do not have any saved credit cards on file. Click
                        the Add Card button below to add a credit card.
                    </p>
                ) : (
                    ''
                )}
                <div
                    className={wallet.length > 0 ? 'row margin-top-2x' : 'row'}
                >
                    <Button
                        data-test="my-account-add-new-credit-card-button"
                        variant="contained"
                        className="buttonHD margin-top margin-bottom-2x"
                        onClick={() => onAddCard()}
                    >
                        Add New Credit Card
                    </Button>
                </div>
            </>
        );
    }
}

WalletInfo.propTypes = {
    wallet: arrayOf(
        shape({
            walletId: string.isRequired,
            cardType: string.isRequired,
            payType: string.isRequired,
            cardHolderName: string.isRequired,
            cardNumber: string.isRequired,
            lastFourDigits: string.isRequired,
            expiryDate: string.isRequired,
            status: string,
            subsIndicator: string,
        }),
    ).isRequired,
    cardtypes: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    onAddCard: func.isRequired,
    onEditCard: func.isRequired,
    onRemoveCard: func.isRequired,
    onSetDefaultCard: func.isRequired,
};

export default WalletInfo;
